// Payroll Module Action Types

// List runs (optional ?TaxYear)
export const GET_PAYROLL_RUN_LIST = "GET_PAYROLL_RUN_LIST";
export const GET_PAYROLL_RUN_LIST_SUCCESS = "GET_PAYROLL_RUN_LIST_SUCCESS";
export const GET_PAYROLL_RUN_LIST_FAILURE = "GET_PAYROLL_RUN_LIST_FAILURE";

// Run detail
export const GET_PAYROLL_RUN_DATA = "GET_PAYROLL_RUN_DATA";
export const GET_PAYROLL_RUN_DATA_SUCCESS = "GET_PAYROLL_RUN_DATA_SUCCESS";
export const GET_PAYROLL_RUN_DATA_FAILURE = "GET_PAYROLL_RUN_DATA_FAILURE";

// Preview a run (no writes)
export const PAYROLL_CREATE_PREVIEW = "PAYROLL_CREATE_PREVIEW";
export const PAYROLL_CREATE_PREVIEW_SUCCESS = "PAYROLL_CREATE_PREVIEW_SUCCESS";
export const PAYROLL_CREATE_PREVIEW_FAILURE = "PAYROLL_CREATE_PREVIEW_FAILURE";

// Preview run PDF (first item)
export const PAYROLL_CREATE_PREVIEW_PDF = "PAYROLL_CREATE_PREVIEW_PDF";
export const PAYROLL_CREATE_PREVIEW_PDF_SUCCESS =
  "PAYROLL_CREATE_PREVIEW_PDF_SUCCESS";
export const PAYROLL_CREATE_PREVIEW_PDF_FAILURE =
  "PAYROLL_CREATE_PREVIEW_PDF_FAILURE";

// Commit a run
export const PAYROLL_CREATE = "PAYROLL_CREATE";
export const PAYROLL_CREATE_SUCCESS = "PAYROLL_CREATE_SUCCESS";
export const PAYROLL_CREATE_FAILURE = "PAYROLL_CREATE_FAILURE";

// Update a run
export const PAYROLL_UPDATE = "PAYROLL_UPDATE";
export const PAYROLL_UPDATE_SUCCESS = "PAYROLL_UPDATE_SUCCESS";
export const PAYROLL_UPDATE_FAILURE = "PAYROLL_UPDATE_FAILURE";

// Delete a run (soft)
export const PAYROLL_DELETE = "PAYROLL_DELETE";
export const PAYROLL_DELETE_SUCCESS = "PAYROLL_DELETE_SUCCESS";
export const PAYROLL_DELETE_FAILURE = "PAYROLL_DELETE_FAILURE";

// Single payslip data
export const GET_PAYROLL_PAYSLIP_DATA = "GET_PAYROLL_PAYSLIP_DATA";
export const GET_PAYROLL_PAYSLIP_DATA_SUCCESS =
  "GET_PAYROLL_PAYSLIP_DATA_SUCCESS";
export const GET_PAYROLL_PAYSLIP_DATA_FAILURE =
  "GET_PAYROLL_PAYSLIP_DATA_FAILURE";

// Single payslip PDF
export const GET_PAYROLL_PAYSLIP_PDF = "GET_PAYROLL_PAYSLIP_PDF";
export const GET_PAYROLL_PAYSLIP_PDF_SUCCESS = "GET_PAYROLL_PAYSLIP_PDF_SUCCESS";
export const GET_PAYROLL_PAYSLIP_PDF_FAILURE = "GET_PAYROLL_PAYSLIP_PDF_FAILURE";

// HMRC submission history
export const GET_PAYROLL_HMRC_LIST = "GET_PAYROLL_HMRC_LIST";
export const GET_PAYROLL_HMRC_LIST_SUCCESS = "GET_PAYROLL_HMRC_LIST_SUCCESS";
export const GET_PAYROLL_HMRC_LIST_FAILURE = "GET_PAYROLL_HMRC_LIST_FAILURE";

// HMRC retry/submit
export const PAYROLL_HMRC_SUBMIT = "PAYROLL_HMRC_SUBMIT";
export const PAYROLL_HMRC_SUBMIT_SUCCESS = "PAYROLL_HMRC_SUBMIT_SUCCESS";
export const PAYROLL_HMRC_SUBMIT_FAILURE = "PAYROLL_HMRC_SUBMIT_FAILURE";

// HMRC employer settings — save
export const PAYROLL_HMRC_SETTINGS_SAVE = "PAYROLL_HMRC_SETTINGS_SAVE";
export const PAYROLL_HMRC_SETTINGS_SAVE_SUCCESS =
  "PAYROLL_HMRC_SETTINGS_SAVE_SUCCESS";
export const PAYROLL_HMRC_SETTINGS_SAVE_FAILURE =
  "PAYROLL_HMRC_SETTINGS_SAVE_FAILURE";

// HMRC employer settings — read
export const GET_PAYROLL_HMRC_SETTINGS_DATA = "GET_PAYROLL_HMRC_SETTINGS_DATA";
export const GET_PAYROLL_HMRC_SETTINGS_DATA_SUCCESS =
  "GET_PAYROLL_HMRC_SETTINGS_DATA_SUCCESS";
export const GET_PAYROLL_HMRC_SETTINGS_DATA_FAILURE =
  "GET_PAYROLL_HMRC_SETTINGS_DATA_FAILURE";

// Reset transient responses (preview / pdf / create / update / delete / submit)
export const PAYROLL_RESET_RESPONSE = "PAYROLL_RESET_RESPONSE";
